/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-08-30 13:59:33
 */
import { useEffect, useState } from "react";
import { Dropdown, Menu, message, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { setToken } from "@/redux/modules/global/action";
import Avatar from "@/components/user/avatar";
import { useTranslation } from "react-i18next";
import teamOwnerIcon from "@/assets/icons/team/owner@2x.png";
import teamMemberIcon from "@/assets/icons/team/member@2x.png";
import type { MenuProps } from 'antd';
interface ModalProps {
	showModal: (params: { name: number }) => void;
}

const AvatarIcon = (props: any) => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const { setToken } = props;
	const { currentUser, currentTeam } = useSelector(state => state.global);

	const [isOwner, setIsOwner] = useState(false);

	useEffect(() => {
		setIsOwner(currentUser?.id === currentTeam?.ownerId);
	}, [currentUser, currentTeam]);

	// 退出登录
	const logout = () => {
		Modal.confirm({
			icon: <ExclamationCircleOutlined />,
			title: t("menu.logout"),
			content: t("menu.logout.confirm.content"),

			onOk: () => {
				setToken("");
				localStorage.removeItem("nickname");
				localStorage.removeItem("token");

				message.success("Logout successfully");
				navigate("/login");
			}
		});
	};

	const items: MenuProps["items"] = [
		{
			key: "billing",
			label: <span className="dropdown-item">{t("nav.user.dropdown.billing")}</span>,
			onClick: () => navigate("/billing/history")
		},
		{
			key: "team",
			label: <span className="dropdown-item">{t("nav.user.dropdown.team")}</span>,
			onClick: () => navigate("/team")
		},
		{
			key: "account",
			label: <span className="dropdown-item">{t("nav.user.dropdown.account")}</span>,
			onClick: () => navigate("/account/setting")
		},
		{
			key: "referrals",
			label: <span className="dropdown-item">{t("nav.user.dropdown.referrals")}</span>,
			onClick: () => navigate("/account/referrals")
		},
		// {
		// 	type: "divider"
		// },
		{
			key: "log out",
			label: <span className="dropdown-item">{t("nav.user.dropdown.logout")}</span>,
			onClick: logout
		}
	];

	return (
		<>
			<Dropdown
				menu={{items}}
				autoAdjustOverflow={false}
				menuClassName="dropDownPannel"
				align={{ overflow: { adjustX: false, adjustY: false } }}
				placement="bottom"
				arrow
				trigger={["click"]}
			>
				<div className="Avatar_container">
					<div className="Avatar_nickname">
						{isOwner && (
							<div className="teamIdentity">
								<img src={teamOwnerIcon} alt="" />
								<span>Owner</span>
							</div>
						)}
						{!isOwner && (
							<div className="teamIdentity">
								<img src={teamMemberIcon} alt="" />
								<span>Member</span>
							</div>
						)}
						<div className="nickname">{currentUser?.nickname}</div>
					</div>
					<Avatar username={currentUser?.nickname && currentUser?.nickname?.slice(0, 1)} size="40px" fontSize="16px" />
				</div>
			</Dropdown>
		</>
	);
};

const mapDispatchToProps = { setToken };
export default connect(null, mapDispatchToProps)(AvatarIcon);
